import cn from 'clsx'

import { Button, Copy, ImageBox } from 'shared-components'

import { getSanityLink } from 'shared-functions'

import Video from '../../Video/Video'

import { type Text2Columns as Text2ColumnsType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './Text2Columns.module.sass'

type ExtendedText2ColumnsType = Text2ColumnsType & {
    site: string
}

function Text2Columns({
    pretitle,
    title,
    smallerTitle,
    introCopy,
    link,
    copy,
    copy2,
    includeBorders,
    reverse,
    reverseTitleAndCopy,
    mainBackgroundColour,
    video,
    image,
    lightButtonColour,
    darkButtonColour,
}: ExtendedText2ColumnsType) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    const isDark = mainBackgroundColour === 'dark'
    const isWhite = mainBackgroundColour === 'white'

    return (
        <section className={cn(s.Text2Columns, isDark && s.Dark, isWhite && s.White, reverse && s.Reverse)}>
            <div className={cn(s.Cont, 'container', includeBorders && s.Borders)}>
                {image ? (
                    <div className={s.ImageSection}>
                        <ImageBox image={image} width={800} height={800} />
                    </div>
                ) : (
                    <div className={s.VideoSection}>
                        {pretitle && <div className={cn(s.Pretitle, 'smallCaps')}>{pretitle}</div>}
                        <Video video={video} />
                    </div>
                )}
                <div className={cn(s.Main, reverseTitleAndCopy ? s.ReverseMain : '')}>
                    <div className={s.MainIntro}>
                        {title &&
                            (smallerTitle ? (
                                <h2 dangerouslySetInnerHTML={{ __html: title }} />
                            ) : (
                                <h1 dangerouslySetInnerHTML={{ __html: title }} />
                            ))}
                        {introCopy && (
                            <div className={s.IntroCopy}>
                                <Copy copy={introCopy} />
                            </div>
                        )}
                        {_link && (
                            <Button
                                url={_link?.url || ''}
                                title={_link?.title || ''}
                                transparent
                                inverted={isDark}
                                brightBlue={
                                    lightButtonColour === 'bright-blue' && (mainBackgroundColour === 'light' || isWhite)
                                }
                                deepNavy={
                                    lightButtonColour === 'deep-navy' && (mainBackgroundColour === 'light' || isWhite)
                                }
                                skyBlue={darkButtonColour === 'sky-blue' && mainBackgroundColour === 'dark'}
                            />
                        )}
                    </div>
                    {(copy || copy2) && (
                        <div className={s.CopyCont}>
                            {copy && (
                                <div>
                                    <Copy copy={copy} />
                                </div>
                            )}
                            {copy2 && (
                                <div>
                                    <Copy copy={copy2} />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Text2Columns
